import { useLocale } from "next-intl";
import Image from "next/image";
import { Slider } from "./Slider";

type Client = {
  logo: string;
  content: string;
  name: string;
};

type Props = {
  clients: Client[];
  className?: string;
};

const ClientCard = ({ client }: { client: Client }) => {
  const locale = useLocale();

  return (
    <div className="rounded-lg border border-light-blue bg-white p-8 cardShadow transition-all duration-300 hover:shadow-lg">
      <div className=" flex justify-center">
        <div className="relative flex items-center justify-center rounded-full bg-lightGrey">
          <Image
            src={client.logo}
            alt={`${client.name} logo`}
            className="min-h-52 min-w-52 object-contain"
          />
        </div>
      </div>

      <div className="text-center">
        <p
          dir={locale === "ar" ? "rtl" : "ltr"}
          className="mb-4 font-tajwal text-lg leading-relaxed text-brown"
        >
          &ldquo;{client.content}&ldquo;
        </p>
        <h4 className="font-livvic text-xl font-semibold text-primary">
          {client.name}
        </h4>
      </div>
    </div>
  );
};

const OurClients = ({ clients, className = "" }: Props) => {
  return (
    <div className={` ${className}`}>
      <div className="mb-12 flex flex-col items-center gap-10 text-primary">
        <p className="text-md font-semibold uppercase text-primary">
          Our Clients
        </p>
        <h3 className="text-center font-livvic text-4xl font-bold">
          Trusted by Industry Leaders
        </h3>
      </div>

      <Slider
        
        slides={clients.map((client, index) => (
          <div className="px-4 pt-6" key={index}>
            <ClientCard client={client} />
          </div>
        ))}
         breakpoints={{
          768: 2,
          375: 1,
        }}
      />
    </div>
  );
};

export default OurClients;
